module.exports = __webpack_public_path__ + "static/CentralPerk-cf0a3993160818c7d2202a7a2d533789.jpg";